import React from 'react';
import './AboutTeam.css';
import jenniferImage from '../../assets/about/team/Jennifer Cox.jpeg';
import oscarImage from '../../assets/about/team/oscar-mendez.jpeg';

const cards = [
  {
    name: 'Jennifer Cox Mendez',
    role: 'FOUNDER AND CLIENT LANDSCAPER',
    bio: 'Jennifer founded Fresh Start with a clear philosophy: create outdoor spaces that reflect real people and how they live. Her long-term focus on quality and trust shaped the team clients know today.',
    chips: ['20+ Years Experience', 'New Castle, CO'],
    image: jenniferImage,
    imageClass: 'about-team__card-image--jennifer',
  },
  {
    name: 'Oscar Mendez',
    role: 'MAINTENANCE LEAD',
    bio: 'Oscar leads maintenance care, making sure every property receives thoughtful year-round attention. He is known for reliability, detail, and consistent communication with clients.',
    chips: ['Year-Round Maintenance', 'Seasonal Care'],
    image: oscarImage,
    imageClass: 'about-team__card-image--oscar',
  },
  {
    name: 'Connor Scarpa',
    role: 'PROJECT MANAGER',
    bio: 'Connor coordinates projects across the valley, from planning to installation. His field-first approach keeps timelines clear and ensures each detail is followed through.',
    chips: ['Flagstone and Hardscape', 'Years Experience'],
    initials: 'CS',
  },
];

const AboutTeam = () => (
  <section className="about-team">
    <div className="about-team__inner">
      <div className="about-team__header">
        <span className="about-team__tag">MEET THE TEAM</span>
        <h2 className="about-team__heading">
          The people you&apos;ll <span className="about-team__heading-accent">work with</span>
        </h2>
        <p className="about-team__subtext">
          A team with deep knowledge of the valley, its climate, and what it takes to create outdoor spaces
          that hold up beautifully over time.
        </p>
      </div>

      <div className="about-team__cards">
        {cards.map(card => (
          <article key={card.name} className="about-team__card">
            {card.image ? (
              <div className="about-team__card-media">
                <img
                  src={card.image}
                  alt={card.name}
                  className={`about-team__card-image${card.imageClass ? ` ${card.imageClass}` : ''}`}
                />
              </div>
            ) : (
              <div className="about-team__card-initials-wrap">
                <span className="about-team__card-initials">{card.initials}</span>
              </div>
            )}
            <div className="about-team__card-content">
              <h3 className="about-team__card-name">{card.name}</h3>
              <p className="about-team__card-role">{card.role}</p>
              <p className="about-team__card-bio">{card.bio}</p>
              <div className="about-team__chips">
                {card.chips.map(chip => (
                  <span key={chip} className="about-team__chip">
                    {chip}
                  </span>
                ))}
              </div>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default AboutTeam;
